// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const CREATE_DATASET_FROM_FILE_STEP_SHAPES = [
  {
    stepType: PipelineStepType.CREATE_DATASET_FROM_FILE,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      'Input files': {
        systemName: 'Input files',
        displayName: 'Input files',
        kind: PipelineStepDataKind.FILE,
        isMulti: true,
        isRequired: true
      }
    },
    outputDataShapes: {
      Dataset: {
        systemName: 'Dataset',
        displayName: 'Dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    config: {
      datasetName: {
        kind: 'string',
        required: true
      },
      csvDelimiter: {
        kind: 'enum',
        required: true,
        choices: [
          'Comma (`,`)',
          'Space (` `)',
          'Tab (`\u00a0\u00a0\u00a0\u00a0`)',
          'Pipe (`|`)',
          'Custom value'
        ]
      },
      customCsvDelimiter: {
        kind: 'string',
        required: false
      },
      dataLocale: {
        kind: 'enum',
        required: true,
        choices: [
          'International (12 hour)',
          'International (24 hour)',
          'Afrikaans',
          'Afrikaans (Namibia)',
          'Afrikaans (South Africa)',
          'Akan',
          'Albanian',
          'Albanian (Regional)',
          'Arabic',
          'Arabic (Morocco)',
          'Arabic (Regional)',
          'Arabic (Saudi Arabia)',
          'Armenian',
          'Azerbaijani',
          'Azerbaijani (Regional)',
          'Basque',
          'Basque (Regional)',
          'Belarusian',
          'Bengali',
          'Bengali (Bangladesh)',
          'Bengali (India)',
          'Bosnian',
          'Bulgarian',
          'Bulgarian (Regional)',
          'Burmese',
          'Catalan',
          'Catalan (Regional)',
          'Chinese',
          'Chinese Simplified',
          'Chinese Simplified (China)',
          'Chinese Simplified (Singapore)',
          'Chinese Traditional',
          'Chinese Traditional (Hong Kong)',
          'Chinese Traditional (Taiwan)',
          'Croatian',
          'Croatian (Regional)',
          'Czech',
          'Czech (Regional)',
          'Danish',
          'Danish (Regional)',
          'Dutch',
          'Dutch (Belgium)',
          'Dutch (Netherlands)',
          'English',
          'English (Australia)',
          'English (Canada)',
          'English (India)',
          'English (Ireland)',
          'English (South Africa)',
          'English (UK)',
          'English (US)',
          'Esperanto',
          'Esperanto (Regional)',
          'Estonian',
          'Estonian (Estonia)',
          'Faroese',
          'Filipino',
          'Filipino (Regional)',
          'Finnish',
          'Finnish (Regional)',
          'French',
          'French (Belgium)',
          'French (Canada)',
          'French (France)',
          'French (Switzerland)',
          'Frisian (West)',
          'Fulah',
          'Galician',
          'Galician (Regional)',
          'Georgian',
          'German',
          'German (Austria)',
          'German (Germany)',
          'German (Switzerland)',
          'Greek',
          'Greek (Greece)',
          'Gujarati',
          'Hebrew',
          'Hebrew (Regional)',
          'Hindi',
          'Hindi (Regional)',
          'Hungarian',
          'Hungarian (Regional)',
          'Icelandic',
          'Icelandic (Iceland)',
          'Indonesian',
          'Indonesian (Regional)',
          'Irish',
          'Irish (Gaelic)',
          'Italian',
          'Italian (Regional)',
          'Japanese',
          'Japanese (Regional)',
          'Javanese',
          'Kabyle',
          'Kannada',
          'Kannada (India)',
          'Kazakh',
          'Khmer',
          'Khmer (Regional)',
          'Korean',
          'Korean (Korea)',
          'Kurdish',
          'Latin',
          'Latvian',
          'Latvian (Regional)',
          'Lithuanian',
          'Lithuanian (Regional)',
          'Lower Sorbian',
          'Luxembourgish',
          'Macedonian',
          'Macedonian (Macedonian)',
          'Maithili',
          'Malagasy',
          'Malay',
          'Malay (Regional)',
          'Malayalam',
          'Malayalam (Regional)',
          'Maltese',
          'Maltese (Regional)',
          'Marathi',
          'Marathi (Regional)',
          'Mongolian',
          'Nepali',
          'Nepali (Regional)',
          'Northern S\u00e1mi',
          'Norwegian',
          'Norwegian (bokmal)',
          'Norwegian (bokmal) (Regional)',
          'Norwegian (nynorsk)',
          'Oriya',
          'Pashto',
          'Persian',
          'Persian (Regional)',
          'Polish',
          'Polish (Regional)',
          'Portuguese',
          'Portuguese (Brazil)',
          'Portuguese (Portugal)',
          'Punjabi',
          'Punjabi (India)',
          'Quechua',
          'Romanian',
          'Romanian (Regional)',
          'Romansh',
          'Russian',
          'Russian (Regional)',
          'Sanskrit',
          'Serbian',
          'Serbian (Serbia)',
          'Sinhala (Sri Lanka)',
          'Slovak',
          'Slovak (Slovakia)',
          'Slovenian',
          'Slovenian (Regional)',
          'Somali',
          'Spanish',
          'Spanish (Argentina)',
          'Spanish (Chile)',
          'Spanish (Colombia)',
          'Spanish (Ecuador)',
          'Spanish (Latin America) (es-419)',
          'Spanish (Latin America) (es-LA)',
          'Spanish (Mexico)',
          'Spanish (Nicaragua)',
          'Spanish (Spain)',
          'Spanish (United States)',
          'Spanish (Venezuela)',
          'Sundanese',
          'Swahili',
          'Swahili (Kenya)',
          'Swedish',
          'Swedish (Regional)',
          'Tajik',
          'Tajik (Regional)',
          'Tamil',
          'Tamil (Regional)',
          'Tatar',
          'Telugu',
          'Telugu (Regional)',
          'Thai',
          'Thai (Thailand)',
          'Turkish',
          'Turkish (Regional)',
          'Ukrainian',
          'Ukrainian (Regional)',
          'Upper Sorbian',
          'Urdu',
          'Urdu (Regional)',
          'Uzbek',
          'Uzbek (Regional)',
          'Vietnamese',
          'Vietnamese (Regional)',
          'Welsh',
          'Welsh (Regional)',
          'Xhosa',
          'Yiddish',
          'Zulu'
        ]
      },
      sheetName: {
        kind: 'string',
        required: false
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
